import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '';
      case 'error':
        return '';
      case 'warning':
        return '';
      case 'info':
      default:
        return '';
    }
  };

  const icon = getIcon();
  
  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        {icon && <span className="toast-icon">{icon}</span>}
        <div className="toast-message" style={{ whiteSpace: 'pre-line' }}>
          {message}
        </div>
      </div>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
};

export default Toast; 